"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColossalSmashAbilityHandler = exports.ColossalSmashActorAbilityFactory = exports.ColossalSmashAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class ColossalSmashAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.ColossalSmash;
        this.__typeName = "ColossalSmash";
    }
}
exports.ColossalSmashAbilityArgs = ColossalSmashAbilityArgs;
let ColossalSmashActorAbilityFactory = class ColossalSmashActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("ColossalSmash", "OneEnemies", 0);
    }
};
ColossalSmashActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("ColossalSmash")
], ColossalSmashActorAbilityFactory);
exports.ColossalSmashActorAbilityFactory = ColossalSmashActorAbilityFactory;
let ColossalSmashAbilityHandler = class ColossalSmashAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [targetId] = ability.args.target.actorIds;
        container.applyMultiAttack({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "melee",
            attackerId: ability.invokerId,
            targets: [
                {
                    targetId,
                    jitter: 0,
                    damages: [
                        AbilityDamage_1.AbilityDamage.Power("Physical", 60),
                        AbilityDamage_1.AbilityDamage.Power("Fire", 60),
                    ],
                    effects: [
                        {
                            targetId,
                            duration: Duration_1.Duration.Permanent,
                            effect: new core_1.BurningEffectArgs("Power", 10),
                        }
                    ]
                }
            ]
        });
    }
};
ColossalSmashAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.ColossalSmash)
], ColossalSmashAbilityHandler);
exports.ColossalSmashAbilityHandler = ColossalSmashAbilityHandler;
